<div class="wizard-step-selection" [class.selected]="isSelected()" [class.is-small]="small()" [class.disabled]="isDisabled()">
  @if(icon()) {
  <div>
    <ion-icon class="large" [name]="icon()"></ion-icon>
  </div>
  }
  <div class="wizard-step-selection-description">
    <ion-text color="dark">
      @if(name()) {
      <h4>{{ name() | localized }}</h4>
      } @else {
      <h4>{{ nameString() ?? "" | translate }}</h4>
      }
    </ion-text>

    @if(!!description) {
    <ion-text color="medium" class="wizard-step-selection-sub-description">
      @if(description()) {
      <h5>{{ description() | localized }}</h5>
      } @else {
      <h5>{{ descriptionString() ?? "" | translate }}</h5>
      }
    </ion-text>
    }
  </div>
  <div class="wizard-step-selection-radio">
    @if(isCheckbox()) {
    <ion-checkbox mode="md" slot="end" [checked]="isSelected()" [disabled]="isDisabled()"> </ion-checkbox>
    } @else {
    <ion-radio [value]="item()" mode="md" [disabled]="isDisabled()"></ion-radio>
    }
  </div>
</div>
